
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-inflector/index", function(){ return i("ember-inflector/index");});
d("ember-inflector/lib/helpers/pluralize", function(){ return i("ember-inflector/lib/helpers/pluralize");});
d("ember-inflector/lib/helpers/singularize", function(){ return i("ember-inflector/lib/helpers/singularize");});
d("ember-inflector/lib/system", function(){ return i("ember-inflector/lib/system");});
d("ember-inflector/lib/system/inflections", function(){ return i("ember-inflector/lib/system/inflections");});
d("ember-inflector/lib/system/inflector", function(){ return i("ember-inflector/lib/system/inflector");});
d("ember-inflector/lib/system/string", function(){ return i("ember-inflector/lib/system/string");});
d("ember-inflector/lib/utils/make-helper", function(){ return i("ember-inflector/lib/utils/make-helper");});
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-inflector/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
